var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0-Base/icons/-menu",
    transform: "translate(0.000000, -2.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bars",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.28571429 C0,0.575892857 0.575892857,0 1.28571429,0 L22.7142857,0 C23.4267857,0 24,0.575892857 24,1.28571429 C24,1.99821429 23.4267857,2.57142857 22.7142857,2.57142857 L1.28571429,2.57142857 C0.575892857,2.57142857 0,1.99821429 0,1.28571429 Z M0,9.85714286 C0,9.14464286 0.575892857,8.57142857 1.28571429,8.57142857 L22.7142857,8.57142857 C23.4267857,8.57142857 24,9.14464286 24,9.85714286 C24,10.5696429 23.4267857,11.1428571 22.7142857,11.1428571 L1.28571429,11.1428571 C0.575892857,11.1428571 0,10.5696429 0,9.85714286 Z M22.7142857,19.7142857 L1.28571429,19.7142857 C0.575892857,19.7142857 0,19.1410714 0,18.4285714 C0,17.7160714 0.575892857,17.1428571 1.28571429,17.1428571 L22.7142857,17.1428571 C23.4267857,17.1428571 24,17.7160714 24,18.4285714 C24,19.1410714 23.4267857,19.7142857 22.7142857,19.7142857 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.ddaf4b6ffe2dd6ec779480e40ac8e9f2.svg";
export { ForwardRef as ReactComponent };